import React, { Component } from "react";
import { FiCheck } from "react-icons/fi";
import { StaticImage } from "gatsby-plugin-image";

class NewsTabs extends Component {
    render() {
        return (
            <div className="tabs-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="single-tab-content mt-4">
                                <div className="row">
                                    <div className="col-md-7 pr-5 pt-4">

                                        <p className="text-primary text-uppercase mb--0 fontWeight400" style={{"fontSize": "0.875rem"}}>
                                            Ljubljana – Litija, sobota, 13. junij 2026
                                        </p>

                                        <h3>
                                            MUZEJSKI VLAK PRIHAJA V LITIJO
                                        </h3>

                                        <p className="mb-15px fontWeight600 font-italic">
                                            Doživite Litijo drugače – z Muzejskim vlakom!
                                        </p>

                                        <p className="mb-15px">
                                            Iz Ljubljane se boste podali na nepozabno potovanje skozi čas po
                                            železniški progi – do Litije. Vožnja z zgodovinskim vlakom ponuja
                                            edinstveno priložnost za druženje, občudovanje čudovite pokrajine
                                            ter odkrivanje lokalne kulturne, naravne in kulinarične dediščine.
                                            Zagotovo ne pričakujete, koga vse lahko srečate na poti!
                                        </p>

                                        <p className="mb-15px">
                                            Po vožnji z Muzejskim vlakom vas čakajo skrbno pripravljeni
                                            programi in doživetja, med katerimi lahko izberete tistega, ki vam
                                            je najbližje.
                                        </p>

                                        <p className="mb-15px fontWeight600">
                                            Izberite svoj program in se nam pridružite na nepozabnem dnevu v
                                            Litiji!
                                        </p>

                                        <p className="mb--0 fontWeight600">
                                            Pustolovščina med krošnjami Geossa:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />vožnja z muzejskim vlakom,</li>
                                            <li><FiCheck />avtobusni prevoz do Pustolovskega parka Geoss,</li>
                                            <li><FiCheck />vstop in program v parku, malica iz košare.</li>
                                        </ul>

                                        <p className="mb--0 fontWeight600">
                                            Skrivnosti mineralov in narave:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />vožnja z muzejskim vlakom,</li>
                                            <li><FiCheck />obisk rudnika Sitarjevec in okušanje sitarjevške mal’ce,</li>
                                            <li><FiCheck />ogled Parka Zeleni raj,</li>
                                            <li><FiCheck />organiziran avtobusni prevoz.</li>
                                        </ul>

                                        <p className="mb--0 fontWeight600">
                                            Muzejski vlak z animacijo in lokalnimi okusi:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />vožnja z muzejskim vlakom,</li>
                                            <li><FiCheck />animacijski program s škratom Sitarjevčkom, zeliščarko in vedeževalko,</li>
                                            <li><FiCheck />kulinarična pogostitev z lokalnimi dobrotami,</li>
                                            <li><FiCheck />predstavitev lokalnih zgodb in legend.</li>
                                        </ul>

                                        <p className="mb--0 fontWeight600">
                                            Oglarska dediščina Litije:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />enosmerna vožnja z muzejskim vlakom Ljubljana – Litija,</li>
                                            <li><FiCheck />obisk Oglarske domačije Brinovec s pogostitvijo,</li>
                                            <li><FiCheck />ogled in koncert v muzeju starodobnih klaviatur Polymelos na Dolah pri Litiji,</li>
                                            <li><FiCheck />organiziran avtobusni prevoz med lokacijami.</li>
                                        </ul>

                                        <p className="mb--0 fontWeight600">
                                            Na vlak vstopite v Ljubljani:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />zjutraj ob 9.20 in</li>
                                            <li><FiCheck />popoldan ob 13.17.</li>
                                        </ul>

                                        <p className="mb-15px">
                                            Odhode in prihode vlaka si poglejte na{" "}
                                            <a
                                                href="https://potniski.sz.si/vozni-redi/muzejski-vlak/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                spletni strani SŽ
                                            </a>
                                            , prav tako tudi podrobnejše informacije o programih in cenik.
                                        </p>

                                        <p className="mb-15px fontWeight600">
                                            Organizatorja: TIC Litija in Slovenske železnice. Se vidimo na
                                            muzejskem vlaku v Litiji!
                                        </p>
                                    </div>

                                    <div className="col-md-5 flex justify-content-start align-items-start mt-3">
                                        <div className="thumb hover-slide-up">
                                            <StaticImage
                                                src="../../assets/images/news/muzejski-vlak-2026-sl.png"
                                                alt="Muzejski vlak Ljubljana – Litija"
                                                placeholder="blurred"
                                                imgClassName="img-fluid w-100"
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default NewsTabs;
